var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',{on:{"tab-change":_vm.handleTabChange}},[_c('TabPanel',{attrs:{"header":"สรุปจำนวนพื้นที่เสี่ยงภัย"}},[_c('report-risk-area-amount')],1),_c('TabPanel',{attrs:{"header":" กราฟสรุปจำนวนพื้นที่เสี่ยงภัย"}},[_c('report-risk-area-graph')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }